import { render, staticRenderFns } from "./AtividadesCrianca.vue?vue&type=template&id=3003d100"
import script from "./AtividadesCrianca.vue?vue&type=script&lang=js"
export * from "./AtividadesCrianca.vue?vue&type=script&lang=js"
import style0 from "./AtividadesCrianca.vue?vue&type=style&index=0&id=3003d100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports